import { useAnchorClientLimitContext } from './Context';

const useAnchorClientLimitViewModel = () => {
  const { anchorClientLimitInfo, fetchAnchorClientLimitInfo } = useAnchorClientLimitContext();

  return { anchorClientLimitInfo, fetchAnchorClientLimitInfo };
};

export default useAnchorClientLimitViewModel;
